<template>
  <div id="episodeFilter">
    <h4>Filter By</h4>
    <div class="filterSelector yearSelector" tabindex="-1" v-on-clickaway="toggleYearOff">
      <div class="selectorValue" @click="toggleYear">
        {{ $parent.year || 'Year' }}
        <img src="../../assets/images/FilterCaret.svg" width="18" height="10" :class="yearToggled ? 'toggled' : ''">
      </div>
      <div class="selectorOptions" v-if="yearToggled">
        <p @click="selectYear($event)" data-value="">
          <iconify-icon icon="mdi:close" /> Clear Filter
        </p>
        <ul>
          <li @click="selectYear($event)" v-for="yr in years" :data-value="yr">{{ yr }}</li>
        </ul>
      </div>
    </div>
    <div class="filterSelector topicSelector" tabindex="-1" v-on-clickaway="toggleTopicOff">
      <div class="selectorValue" @click="toggleTopic">
        {{ $parent.thisTopic ? $parent.thisTopic.name : 'Topic' }}
        <img src="../../assets/images/FilterCaret.svg" width="18" height="10" :class="topicToggled ? 'toggled' : ''">
      </div>
      <div class="selectorOptions" v-if="topicToggled">
        <p @click="selectTopic($event)" data-value=""><iconify-icon icon="mdi:close" /> Clear Filter</p>
        <ul>
          <li @click="selectTopic($event)" v-for="topic in topics" :data-value="topic.slug">{{ topic.name }}</li>
        </ul>
      </div>
    </div>
    <div class="spacer"></div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'episode-filter',
  data () {
    return {
      topicToggled: false,
      yearToggled: false
    }
  },
  mixins: [ clickaway ],
  mounted () {
    this.fetchTopics()
  },
  methods: {
    fetchTopics () {
      let vm = this
      // GET /topics => get_topics() [theme-folder]/api/functions.php
      vm.$axios.get('/topics', {
        params: {
          type: 'episode'
        }
      })
      .then((response) => {
        vm.$parent.topics = response.data.topics
        vm.$parent.years = response.data.years
      })
      .catch((err) => {
        console.log(err.response)
      })
    },
    toggleTopic () {
      this.topicToggled = !this.topicToggled
    },
    toggleYear () {
      this.yearToggled = !this.yearToggled
    },
    toggleTopicOff () {
      this.topicToggled = false
    },
    toggleYearOff () {
      this.yearToggled = false
    },
    selectTopic (e) {
      let vm = this
      if (vm.year) {
        vm.$router.replace({name: 'Category', params: { topic: e.target.dataset.value }, query: { year: vm.year }})
      } else {
        vm.$router.replace({name: 'Category', params: { topic: e.target.dataset.value }})
      }
      vm.toggleTopicOff()
    },
    selectYear (e) {
      let vm = this
      if (vm.topic) {
        vm.$router.replace({name: 'Category', params: { topic: vm.topic }, query: { year: e.target.dataset.value }})
      } else {
        vm.$router.replace({name: 'Episodes', query: { year: e.target.dataset.value }})
      }
      vm.toggleYearOff()
    }
  },
  computed: {
    year () {
      return this.$parent.year
    },
    topic () {
      return this.$parent.topic
    },
    topics () {
      return this.$parent.topics
    },
    years () {
      return this.$parent.years
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  @import ../../assets/styles/mixins

  #episodeFilter
    border-top: 1px solid #95989a
    margin-bottom: 10px
    +until($tablet)
      padding: 10px 15px 0
    +tablet
      margin-bottom: 44px
      max-width: 540px
      display: flex
      align-items: center
      justify-content: space-between
    +smDesktop
      margin-left: auto
      margin-right: 0
      max-width: 504px
    +desktop
      max-width: 610px
    h4
      margin-bottom: 0
      font-size: 20px
      font-weight: bold
      text-transform: uppercase
      width: 110.86px
      line-height: 26px
    .spacer
      width: 73.29px
</style>



// WEBPACK FOOTER //
// EpisodeFilter.vue?78921b06